import React, { Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CompanySizeSelect from '../forms/selects/CompanySizeSelect';
import CountrySelect from '../forms/selects/CountrySelect';
import StateSelect from '../forms/selects/StateSelect';
import IndustrySelect from '../forms/selects/IndustrySelect';
import OccupationSelect from '../forms/selects/OccupationSelect';

import { FormContext } from './Form';

const CountryAndState = ({ secondaryName, ...props }) => {
  const [showStates, setShowStates] = useState();
  const { t } = useTranslation();
  const secondaryId = `state_${secondaryName}`;

  return (
    <Fragment>
      <CountrySelect
        withFavorites
        {...props}
        onChange={e => {
          setShowStates(e.target.value === 'United States');
        }}
      />

      {showStates && (
        <Fragment>
          <label htmlFor={secondaryId}>{t('State')}</label>
          <StateSelect
            {...props}
            name={secondaryName || 'state'}
            id={secondaryId}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

const getField = (type, allProps) => {
  const { secondaryName, ...props } = allProps;
  switch (type) {
    case 'occupation':
      return <OccupationSelect {...props} />;
    case 'country':
      return <CountrySelect withFavorites {...props} />;
    case 'countryAndUsState':
      return <CountryAndState secondaryName={secondaryName} {...props} />;
    case 'usState':
      return <StateSelect {...props} />;
    case 'companySize':
      return <CompanySizeSelect {...props} />;
    case 'industry':
      return <IndustrySelect {...props} />;
    case 'factorySolutionsIndustry':
      return <IndustrySelect factorySolutions {...props} />;
    default:
      return null;
  }
};

const PresetSelect = ({
  label,
  name,
  isRequired,
  type,
  secondaryName,
  onChange,
  value
}) => {
  const { formName, invalidFields } = useContext(FormContext);
  const id = `${formName}_${type}_${name}`;

  const hasError = invalidFields.includes(name);

  return (
    <Fragment>
      {label ? (
        <label aria-hidden="true" htmlFor={id}>
          {label}
        </label>
      ) : null}
      {getField(type, {
        id,
        name,
        required: isRequired,
        secondaryName,
        hasError,
        onChange,
        defaultValue: value,
        'aria-label': label
      })}
    </Fragment>
  );
};

export default PresetSelect;
